<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 15H15V11H13.5V8.5C13.5 8.23478 13.3946 7.98043 13.2071 7.79289C13.0196 7.60536 12.7652 7.5 12.5 7.5H8.5V5H10V1L6 1V5H7.5V7.5H3.5C3.23478 7.5 2.98043 7.60536 2.79289 7.79289C2.60536 7.98043 2.5 8.23478 2.5 8.5V11H1V15H5V11H3.5V8.5H7.5V11H6V15H10V11H8.5V8.5H12.5V11H11V15ZM7 4V2H9V4H7ZM4 12V14H2V12H4ZM9 12V14H7V12H9ZM14 12V14H12V12H14Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'OrgTreeIcon',
};
</script>
